import { render } from "./PhotosListTableComponent.vue?vue&type=template&id=b7f1de8a&scoped=true&ts=true"
import script from "./PhotosListTableComponent.vue?vue&type=script&lang=ts"
export * from "./PhotosListTableComponent.vue?vue&type=script&lang=ts"

import "./PhotosListTableComponent.vue?vue&type=style&index=0&id=b7f1de8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f1de8a"]])

export default __exports__